import { render, staticRenderFns } from "./TournamentMainEventCard.vue?vue&type=template&id=c2f71c64&scoped=true&"
import script from "./TournamentMainEventCard.vue?vue&type=script&lang=js&"
export * from "./TournamentMainEventCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f71c64",
  null
  
)

export default component.exports